<div class="wrapper" [ngClass]="{'wrapper--pushed': showSidebar}"
     [ngStyle]="styles.wrapper">
  <div class="wrapper__main">
    <ng-content></ng-content>
  </div>

  <ng-container *ngIf="contentTemplateRef">
    <div class="wrapper__overlay" (click)="onOverlayClick()"></div>
    <div class="wrapper__aside" [ngStyle]="styles.aside">
      <ng-template [ngTemplateOutlet]="contentTemplateRef"></ng-template>
    </div>
  </ng-container>
</div>
